import React from 'react';

const Title = () => {
  return (
    <div className="title">
      <h1>Gallery @poojitha</h1>
      <h2>Add Your Pictures</h2>
      <p>Pictures are always memorable</p>
    </div>
  )
}

export default Title;